import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const ModalWindowHeaderTitle = props => {
  const { className, children, ...other } = props;

  return (
    <h3 className={clsx("em-c-modal__title", className)} {...other}>
      {children}
    </h3>
  );
};

ModalWindowHeaderTitle.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

ModalWindowHeaderTitle.defaultProps = {
  className: "",
  children: null
};

export default ModalWindowHeaderTitle;
